<template>
  <div>
    <!-- <settings-top-nav :selectedBinId="selectedBinInfo.bin_id" :componentname="selectedBinComponent"
    @changeToSelectedBinComponent='changeSelectedBinComponent' :showAddBinButton="selectedBinComponent != 'add-bin'"></settings-top-nav> -->
    <!-- :selectedBinId="selectedBinInfo.bin_id" -->
    <component :is="selectedWebHookComponent"
    :selectedWebHookName="selectedWebhookInfo.hookscript_name"
    :selectedWebhookInfo="selectedWebhookInfo"
    @changeToSelectedwebhookComponent='changeSelectedWebhookComponent'
    :isEditMode="isEditMode"
    :triggersList="triggersList"
     v-bind="currentProperties"></component>
  </div>
</template>

<script>
import Addwebhook from "./webHookwindow.vue"
import ShowWebhook from "./webhookworkspace.vue"
import { mapActions } from "vuex";

// import settingsTopNav from "./HeaderBar.vue"

export default {
  name: "Bins",
  data() {
    return {
      selectedWebHookComponent: "show-webhook",
      selectedWebhookInfo: {},
      isEditMode: false,
      triggersList : [],
    };
  },
  components: {
    "add-webhook": Addwebhook,
    // "webhook-info": webhookInfo,
    // "settings-top-nav": settingsTopNav,
    "show-webhook": ShowWebhook,
  },
  created(){
    this.getTriggersList();
  },

  methods: {
    // changeSelectedWebhookComponent(compName, webhookInfo={}) {
    changeSelectedWebhookComponent(compName, webhookInfo={}) {  
      this.selectedWebHookComponent = compName;
      if(![undefined, null].includes("webhookInfo") && Object.keys(webhookInfo).length>0){
        this.selectedWebhookInfo = webhookInfo;
        this.isEditMode = true;
      }else{
        this.selectedWebhookInfo = {};
        this.isEditMode = false;
      }

    },
    getTriggersList(){    
        this.getTriggersFromServer().then((data) =>{
            this.triggersList = data.triggers;
        });  
    },
    showBinsTopNav() {
      let comps = [
        "add-bin",
        "bins-info"
      ];
      if (comps.indexOf(this.selectedWebHookComponent) > -1) {
        return true;
      }
    },
    ...mapActions("webHook", ["getTriggersFromServer"]),
  },
  computed:{
      currentProperties() {
      if (this.selectedWebHookComponent === "webhook-info") {
        return { selectedWebHookName : this.selectedWebhookInfo.hookscript_name};
      }
      else{
          return {}
      }
    },
  }
};
</script>

<style scoped>

</style>